import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";
import { useFetch } from "../../lib/useData";
import { PageTitle, Badge, TableWrap, Btn, Modal, Select, Input, DateRange } from "../../components/admin/ui";

export default function Refunds() {
  const [status, setStatus] = useState("all");
  const [range, setRange] = useState({ from: "", to: "" });
  const qs = new URLSearchParams({ status, ...(range.from && { date_from: range.from }), ...(range.to && { date_to: range.to }) }).toString();
  const { data: refunds, loading, reload } = useFetch(`/admin/refunds?${qs}`, [qs]);
  const [detail, setDetail] = useState(null);
  const [ref, setRef] = useState("");
  const [note, setNote] = useState("");

    const act = async (action) => {
    try {
      const { data } = await api.post(`/admin/refunds/${detail.booking_id}`, {
        action,
        refund_reference: ref,
        note: note.trim(),
      });
      toast.success("Refund updated");
      setDetail(data);
      setNote("");
      reload();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  return (
    <div>
      <PageTitle title="Refunds" desc="Track refunds for cancelled and rejected bookings" />
      <div className="flex flex-wrap items-center gap-4 mb-4">
      <div className="w-56"><Select value={status} onChange={setStatus} options={[{ value: "all", label: "All Cancelled / Rejected" }, "not_initiated", "requested", "processing", "completed", "rejected"].map((x) => typeof x === "string" ? { value: x, label: x } : x)} testid="refund-filter" /></div>
      <DateRange from={range.from} to={range.to} onChange={({ from, to }) => setRange({ from, to })} testid="refund-date-range" />
      </div>
      <TableWrap>
        <thead className="bg-slate-800 text-slate-400"><tr>
          <th className="text-left px-4 py-3">Booking ID</th><th className="text-left px-4 py-3">Devotee</th><th className="text-left px-4 py-3">Booking</th><th className="text-left px-4 py-3">Original</th><th className="text-left px-4 py-3">Refund Amt</th><th className="text-left px-4 py-3">Refund Ref</th><th className="text-left px-4 py-3">Status</th><th className="text-right px-4 py-3"></th>
        </tr></thead>
        <tbody className="divide-y divide-slate-700" data-testid="refunds-table">
          {loading ? <tr><td colSpan={8} className="px-4 py-8 text-center text-slate-500">Loading…</td></tr> :
            (refunds || []).map((r) => (
              <tr key={r.id} className="hover:bg-slate-800/50">
                <td className="px-4 py-3 font-semibold text-orange-400">{r.booking_id}</td>
                <td className="px-4 py-3">{r.devotee_name}<div className="text-xs text-slate-500">{r.date}</div></td>
                <td className="px-4 py-3"><Badge status={r.booking_status} /></td>
                <td className="px-4 py-3">₹{r.amount}</td>
                <td className="px-4 py-3 text-emerald-400 font-bold">{r.refund_status === "not_initiated" ? "—" : `₹${r.refund_amount}`}</td>
                <td className="px-4 py-3 text-slate-400">{r.refund_reference || "—"}</td>
                <td className="px-4 py-3"><Badge status={r.refund_status} /></td>
                <td className="px-4 py-3 text-right"><Btn variant="outline" onClick={() => { setRef(r.refund_reference || ""); setNote(""); setDetail(r); }} testid={`refund-manage-${r.booking_id}`}>{r.refund_status === "not_initiated" ? "View" : "Manage"}</Btn></td>
              </tr>
            ))}
          {!loading && (refunds || []).length === 0 && <tr><td colSpan={8} className="px-4 py-8 text-center text-slate-500">No refund requests</td></tr>}
        </tbody>
      </TableWrap>

      <Modal open={!!detail} onClose={() => setDetail(null)} title={`Refund · ${detail?.booking_id}`}>
        {detail && (
          <div className="space-y-3">
            <div className="text-sm space-y-1">
              <div className="flex justify-between"><span className="text-slate-400">Devotee</span><span>{detail.devotee_name}</span></div>
              <div className="flex justify-between"><span className="text-slate-400">Original Amount</span><span>₹{detail.amount}</span></div>
              <div className="flex justify-between"><span className="text-slate-400">Refund Amount</span><span className="text-emerald-400 font-bold">₹{detail.refund_amount}</span></div>
              <div className="flex justify-between"><span className="text-slate-400">Current Status</span><Badge status={detail.refund_status} /></div>
            </div>
            {detail.refund_status === "not_initiated" ? (
              <p className="text-sm text-slate-400">No refund has been initiated for this {detail.booking_status} booking. Open it from the Bookings page and use <strong>Initiate Refund</strong>.</p>
            ) : (<>
            <Input label="Refund Reference / UTR" value={ref} onChange={setRef} testid="refund-ref" />
            <textarea placeholder="Note…" value={note} onChange={(e) => setNote(e.target.value)} rows={2} className="w-full rounded-lg bg-slate-900 border border-slate-600 px-3 py-2 text-sm" />
            <div className="flex gap-2 pt-2">
              <Btn variant="outline" onClick={() => act("process")} testid="refund-process">Mark Processing</Btn>
              <Btn variant="success" onClick={() => act("complete")} testid="refund-complete">Complete Refund</Btn>
              <Btn variant="danger" onClick={() => act("reject")} testid="refund-reject">Reject</Btn>
            </div></>)}
          </div>
        )}
      </Modal>
    </div>
  );
}
